var render = function render(){var _vm=this,_c=_vm._self._c;return _c('picture',[_c('source',{attrs:{"srcset":_vm.webpUrl,"type":"image/webp"}}),_c('source',{attrs:{"srcset":_vm.url,"type":"image/jpeg"}}),_c('img',{class:_vm.className,attrs:{"src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }